import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { PieChart, Pie, Sector, Cell, ResponsiveContainer, Tooltip, Legend, BarChart, XAxis, YAxis, Bar, CartesianGrid } from 'recharts';
import { useDispatch, useSelector } from "react-redux";
import { Spin } from "antd";
import { Grid } from "@mui/material";
import { getRatingGroupsByGeo } from '../../API/api'
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import VizHeader from "../VizHeader/VizHeader";
import { useCurrentPng, } from "recharts-to-png";
import FileSaver, { saveAs } from "file-saver";
import * as htmlToImage from 'html-to-image';
import { Dropdown } from "antd";
import { toSvg, toPng } from "html-to-image";
import { handleError } from "../../utils";



export default function PieChartComponent(props) {
    // const ratingsRef = useRef('Initialize non empty value')
  const expertOverview = useSelector((state) => state.expertOverviewCmReducer);
  const COLORS = ['#009bff','#00b8e6','#b85cff','#5e3bff','#f4c900'];
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch()
  const { getRatingsInExpertOverviewForCM, getRatingStarsInExpertOverviewCM } = bindActionCreators(Actions, dispatch)
  const cmRootReducer = useSelector((state) => state.cmRoot);
  const [activeIndex, setActiveIndex] = useState(null);
  const [getRatingsPng, { ratingsRef,isLoading }] = useCurrentPng();
    const [isRendered, setIsRendered] = useState(false);


  const RADIAN = Math.PI / 180;
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length > 0) {
      console.log(payload,'check payload')
      return (
        <div className="custom-tooltip" style={{border:`1px solid ${payload[0].payload.fill}`,backgroundColor:'#fff'}}>
          <div>
            {payload.map((pld) => (
              <div style={{display: "inline-block", padding: 7, backgroundColor: "#f3f3f3", color: "black", fontSize: "12px" }}>
                <div style={{ color: pld.fill,textTransform:'capitalize' }}>{pld.name}:{" "}<b>{pld.value+`%`}</b></div>
                <p className="label">No. of Ratings:{" "}{pld.payload.ratings}</p>
              </div>
            ))}
          </div>
        </div>
      );
    }
  }

  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };

  const onPieLeave = () => {
    setActiveIndex(-1);
  };

  const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    return (
      <g>
        {/* <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
          {payload.name}
        </text> */}
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
          opacity={0.4}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
        />
        {/* <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" /> */}
        {/* <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" /> */}
        {/* <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${payload.name}`}</text>
        <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
          {`${payload.value}`}
        </text> */}
      </g>
    );
  };

  const items = [
    {
      key: "1",
      label: (
        // <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
        //   1st menu item
        // </a>
        <div onClick={() => handleDownloadPng()}>Download as PNG Image</div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={() => downloadSvgAsJpeg()}>Download as JPEG Image</div>
      ),
    },
    {
      key: "4",
      label: (
        <div onClick={() => handleDownloadSVG()}>Download SVG Vector image</div>
      ),
    },
  ];

//   const handleAreaDownload = React.useCallback(async () => {
//     // 	const png = await getRatingsPng();
//     // 	if (png) {
//     // 		FileSaver.saveAs(png, "ratings-of-expert-answers.png");
//     // 	}
//     // }, [getRatingsPng]
//     const svgElement = ratingsRef.current;

//     if (svgElement) {
//       // Convert the SVG element to a PNG image using html-to-image
//       htmlToImage.toPng(svgElement, { backgroundColor: '#fff' })
//         .then((dataUrl) => {
//           console.log(svgElement,'check svg element')
//           // Create a link element
//           const link = document.createElement('a');

//           // Set the href attribute to the image data URL
//           link.href = dataUrl;

//           // Set the download attribute to specify the filename
//           link.download = 'ratings-of-expert-answers.png';

//           // Append the link to the document, trigger a click, and then remove the link
//           document.body.appendChild(link);
//           link.click();
//           document.body.removeChild(link);
//         })
//         .catch((error) => {
//           console.error('Error downloading image:', error);
//         });
//     }
//   },
// )


const handleAreaDownload = async () => {
  // try {
  //     // Check if the reference is valid
  //     if (ratingsRef.current && isRendered) {
  //         const dataUrl = htmlToImage.toPng(ratingsRef.current, { backgroundColor: '#fff' });
  //         console.log(dataUrl,'check data url')

  //         // Create a download link and trigger the download
  //         const link = document.createElement('a');
  //         link.href = dataUrl;
  //         link.download = 'ratings-of-expert-answers.png';
  //         document.body.appendChild(link);
  //         link.click();
  //         document.body.removeChild(link);
  //     } else {
  //         console.error('ratingsRef.current is null or undefined');
  //     }
  // } catch (error) {
  //     console.error('Error converting to PNG:', error);
  // }
  if(ratingsRef.current)
  {
  htmlToImage.toPng(ratingsRef.current)
  .then(function (dataUrl) {
    // Create a new image element and set its source to the data URL
    var img = new Image();
    img.src = dataUrl;
    
    // Append the image to the document body
    document.body.appendChild(img);
    
    // Create a new anchor (link) element
    var link = document.createElement('a');
    
    // Set the download attribute with the desired filename
    link.download = 'ratings-of-expert-answers.png';
    
    // Set the href attribute to the data URL for downloading
    link.href = dataUrl;
    
    // Append the link to the document body temporarily
    document.body.appendChild(link);
    
    // Programmatically trigger a click event on the link to initiate the download
    link.click();
    
    // Remove the link from the document body after download
    document.body.removeChild(link);
  })
  .catch(function (error) {
    console.error('Oops, something went wrong!', error);
  });
  }
  ratingsRef = null;
};

  function downloadSvgAsJpeg() {
    // htmlToImage.toJpeg(ratingsRef.current, { quality: 0.8, backgroundColor: '#fff' }, { backgroundColor: '#fff' })
    //   .then(function (dataUrl) {
    //     var link = document.createElement('a');
    //     link.download = 'ratings-of-expert-answers.jpeg';
    //     link.href = dataUrl;
    //     link.click();
    //   });
        const options = {
        quality: 0.8,
        backgroundColor: '#fff', // Add the background color if necessary
    };

    // Use htmlToImage.toJpeg to convert the element to a JPEG image
    htmlToImage.toJpeg(ratingsRef.current, options)
        .then((dataUrl) => {
            // Create an anchor element to download the image
            const link = document.createElement('a');
            link.download = 'ratings-of-expert-answers.jpeg';
            link.href = dataUrl;
            link.click();
        })
        .catch((error) => {
            // Handle any errors that may occur during the conversion process
            console.error('Error downloading image:', error);
        });
  }

  const handleDownloadSVG = async () => {
    // const chartContainer = document.getElementsByClassName('recharts-wrapper')[3]
    // const chartContainer2 = document.getElementsByClassName('recharts-wrapper')[2]
    // const chartSvg = (chartContainer + chartContainer2).querySelector("svg");
    // const chartXml = new XMLSerializer().serializeToString(chartSvg);
    // const svgBlob = new Blob([chartXml], {
    // 	type: "image/svg+xml;charset=utf-8",
    // });
    // saveAs(svgBlob, "ratings-of-expert-answers.svg");

    // if (ratingsRef.current) {
    //   const svgString = await toSvg(ratingsRef.current);
    //   const blob = new Blob([svgString], { type: 'image/svg' });
    //   const url = URL.createObjectURL(blob);
    //   const link = document.createElement('a');
    //   link.href = url;
    //   link.download = 'ratings-of-expert-answers.svg';
    //   link.click();
    //   URL.revokeObjectURL(url);
    // }

    // const element = ratingsRef.current
    // if (element) {
    //   toSvg(element).then((svgString) => {
    //     const svgBlob = new Blob([svgString], { type: 'image/svg+xml' });
    //     const urlObject = URL.createObjectURL(svgBlob);
    //     const downloadLink = document.createElement('a');
    //     downloadLink.href = urlObject;
    //     console.log(urlObject,'check download link if created')
    //     // downloadLink.download = 'ratings-of-expert-answers.svg'; // Specify the filename with .svg extension
    //     FileSaver.saveAs(urlObject, 'my-node.svg');

    //     downloadLink.click();

    //     URL.revokeObjectURL(urlObject);

    //   }).catch((error) => {
    //     console.error('Error converting element to SVG:', error);
    //   });

    

        // Convert the chart container to an SVG data URL
        // console.log(ratingsRef.current,'check why it is not wwrking');
      
        const svgDataUrl = await htmlToImage.toSvg(ratingsRef.current);
        // console.log(svgDataUrl,'check svg data url')

        // Create a link element
        const link = document.createElement('a');
        link.href = svgDataUrl;
        link.download = 'ratings-of-expert-answers.svg'; // Specify the file name

        // Append the link to the document body
        document.body.appendChild(link);

        // Programmatically click the link to start the download
        link.click();

        // Remove the link from the document body
        document.body.removeChild(link);
  };

  const handleDownloadPng = useCallback(async () => {
    const png = await getRatingsPng();
    // console.log(png,'check png......')

    // Verify that png is not undefined
    if (png) {
        // Download with FileSaver
        FileSaver.saveAs(png, 'ratings-of-expert-answers.png');
    }
}, [getRatingsPng]);

const renderLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index,payload }) => {
  // console.log(payload.payload.name,'check payload')
  if (expertOverview.ratingStars.length > 0) {
    // Calculate the coordinates for placing the label
    const RADIAN = Math.PI / 180;
    const x = cx + (outerRadius + 24) * Math.cos(-midAngle * RADIAN);
    const y = cy + (outerRadius + 35) * Math.sin(-midAngle * RADIAN);
    return (
      <text
        x={x}
        y={y}
        fill={payload.payload.value > 0&& payload.fill}
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
        style={{textTransform:'capitalize'}}
      >
        {payload && payload.payload.value > 0 && payload.payload.name}{payload.payload.value > 0 &&':'}{" "}{payload && payload.payload.value > 0 && payload.payload.value + `%`}
      </text>
    );
  }
};


const hideLabelLineIfZero = ({ value,entry,payload }) => {
  // console.log(entry,value,payload)
  return value === 0 ? { stroke: 'none' } : {stroke:payload.fill};};


  useEffect(() => {
    setIsRendered(true)
    if (cmRootReducer.selecetdRoutingValue !== "") {
      setLoading(true)
      getRatingGroupsByGeo(cmRootReducer.selecetdRoutingValue, cmRootReducer.selectedGeoLevel.length === 0 ? "" : cmRootReducer.selectedGeoLevel.label, false, cmRootReducer.selectedDomainIds).then((res) => {
        if(res===undefined)return;
        if (res.data.data && res.data.data !== undefined || res.data.success) {
          // console.log(res.data.data,'check response data')
          setLoading(false)
          getRatingsInExpertOverviewForCM(res.data.data);
          getRatingStarsInExpertOverviewCM(res.data.data);
        }
      }).catch((err)=>{
        handleError(err)
      })
    }
  //   return () => {
  //     setIsRendered(false);
  // };
  }, [cmRootReducer.selecetdRoutingValue, cmRootReducer.selectedGeoLevel.length === 0 ? null : cmRootReducer.selectedGeoLevel.label, cmRootReducer.selectedDomainIds])

  const CustomTooltipRated = ({ active, payload, label }) => {
    if (active && payload && payload.length > 0) {
      // console.log(payload,'check payload')
      return (
        <p className="custom-tooltip" style={{backgroundColor:'#fff',border:`1px solid #ececec`,padding:'5px'}}>
          {
            payload?.map((obj,ind)=>{
              return(
                <p className="label" key={ind}>
                  {obj?.payload?.name}:{" "}{obj?.payload?.value}
                </p>
              )
            })
          }
        </p>
      )
    }
  }
  return (
    <>
      <Spin spinning={loading}>
      <div style={{textAlign:'center',paddingTop:'10px'}}><VizHeader type={4} isBold={true}>Ratings of Expert Answers</VizHeader></div>

        <div>
          {/* <div style={{ display: 'flex', paddingTop: "10px", width: '100%' }}> */}
            {/* <div style={{ width: '30%' }}>
            </div> */}
            {/* <div style={{ width: '40%' }}>
              <VizHeader type={4} isBold={true}>Ratings of Expert Answers</VizHeader>
            </div> */}
            {/* <div style={{ width: '30%', display: 'flex', justifyContent: 'flex-end' }}>
              <Dropdown
                menu={{
                  items,
                }}
              >
                <a>
                  <i
                    className="fa fa-ellipsis-h"
                    style={{ fontSize: "20px", color: "lightgray", padding: '5px' }}
                  ></i>
                </a>
              </Dropdown>
            </div> */}
          {/* </div> */}
          <Grid container xs={12} sm={12} md={12}>
            <Grid item xs={12} sm={12} lg={4.9} xl={4.9} md={12}>
              <ResponsiveContainer minWidth={300} width={'100%'} height={400}>
              <BarChart
                data={expertOverview.ratings}
                width={240}
                height={400}
                margin={{
                  top: 18,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
                stackOffset="expand"
                barSize={30}
                ref={ratingsRef}
              >
                <CartesianGrid stroke="#ececec" vertical={false} />
                <Cell style={{ outline: 'none' }} />
                <XAxis minTickGap={400} margin={{ top: 5, right: 30, left: 55, bottom: 20 }} interval={0} dataKey="name" style={{ fontSize: "14px" }}>
                </XAxis>
                <YAxis axisLine={false} tickLine={false} minTickGap={-100} style={{ fontSize: "14px" }} allowDecimals={false} >
                </YAxis>
                <Tooltip wrapperStyle={{ fontFamily: "inherit", fontSize: "12px", fontWeight: 'bold' }} content={<CustomTooltipRated />} />
                <Bar dataKey="value" fill="#009bff" label={{ position: "top", fontWeight: "bold", fontSize: "14px", fontFamily: "inherit" }} />
              </BarChart>
              </ResponsiveContainer>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
              <ResponsiveContainer width={'100%'} minWidth={398} height={420}>
              < PieChart width={400} height={420}>
                <Pie
                  activeIndex={activeIndex}
                  activeShape={renderActiveShape}
                  isAnimationActive={true}
                  paddingAngle={4}
                  data={expertOverview.ratingStars}
                  cx="50%"
                  cy="50%"
                  // labelLine={hideLabelLineIfZero}
                  outerRadius={90}
                  fill="#rgb(124, 181, 236)"
                  dataKey="value"
                  animationEasing="ease-in"
                  // cursor="pointer"
                  minAngle={30}
                  label={renderLabel}
                  onMouseEnter={onPieEnter}
                  onMouseLeave={onPieLeave}
                    // labelLine={({ value }) => ({
                    //   stroke: value > 0 ? 'blue' :'none'
                    // })}                  
                  
                >
                  {expertOverview.ratingStars.length > 0 && expertOverview.ratingStars?.map((entry, index) => (
                    <Cell style={{ outline: 'none' }} key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} wrapperStyle={{ fontSize: '12px', fontWeight: 'bold',}}  />
                {/* <Legend wrapperStyle={{ fontSize: '12px',bottom:9,maxWidth:'90%' }} /> */}
              </PieChart >
              </ResponsiveContainer>
            </Grid>
          </Grid>
        </div>
      </Spin>
    </>
  )
}